import React, { useState, useEffect } from "react";
import {SinhalaData, EnglishData, TamilData} from  "./../../../../dummyData/handbookDummyData";
import { useSelector } from "react-redux";
import PDFViewerImage26 from "../../../../assets/PDFViewerImages/PDFViewerImage26.jpg";
import PDFViewerImage27 from "../../../../assets/PDFViewerImages/PDFViewerImage27.jpg";
import PDFViewerImage28 from "../../../../assets/PDFViewerImages/PDFViewerImage28.jpg";
import PDFViewerImage29 from "../../../../assets/PDFViewerImages/PDFViewerImage29.jpg";
import PDFViewerImage30 from "../../../../assets/PDFViewerImages/PDFViewerImage30.jpg";
import PDFViewerImage31 from "../../../../assets/PDFViewerImages/PDFViewerImage31.jpg";

const Chapter16 = () => {
    const selectedLanguage = useSelector((state) => state.language.language);
  const [language, setLanguage] = useState(SinhalaData[0]);

    useEffect(() => {
        switch (selectedLanguage.value) {
          case "english":
            setLanguage(EnglishData[0]);
            break;
          case "tamil":
            setLanguage(TamilData[0]);
            break;
          default:
            setLanguage(SinhalaData[0]);
            break;
        }
      }, [selectedLanguage]);

    return (
        <>
                {/* Chapter 16 */}
                <section id="section16" className="drivers-handbook-section">
                    <h2 className="drivers-handbook-heading">{language.chapter16Title}</h2>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter16Paragraph1}

                    </p>

                    <div className="image-box">
                        <img src={PDFViewerImage26} alt="Traffic Rules"/>
                    </div>


                    <p className="drivers-handbook-paragraph">
                       {language.chapter16Paragraph2}
                    </p>

                    <div className="image-box">
                        <img src={PDFViewerImage27} alt="Traffic Rules"/>
                    </div>


                    <p className="drivers-handbook-paragraph">
                        {language.chapter16Paragraph3}

                    </p>

                    <div className="image-box">
                        <img src={PDFViewerImage28} alt="Traffic Rules"/>
                    </div>

                    <div className="image-box">
                        <img src={PDFViewerImage29} alt="Traffic Rules"/>
                    </div>

                    <div className="image-box">
                        <img src={PDFViewerImage30} alt="Traffic Rules"/>
                    </div>

                    <div className="image-box">
                        <img src={PDFViewerImage31} alt="Traffic Rules"/>
                    </div>


                    <p className="drivers-handbook-paragraph">
                        {language.chapter16Paragraph4}

                    </p>
                    <p className="drivers-handbook-paragraph">
                        {language.chapter16Paragraph5}
                    </p>
                </section>
        </>
    )

}

export default Chapter16;
